import React from 'react';

/**
 * ScriptureRefEditor - Sub-form for adding Scripture_References with
 * book, chapter, startVerse, and optional endVerse fields.
 *
 * Props:
 * - scriptureRefs: array of { book, chapter, startVerse, endVerse } objects
 * - onChange(scriptureRefs): callback when scripture refs change
 */
function ScriptureRefEditor({ scriptureRefs = [], onChange }) {
  function handleAddRef() {
    onChange([...scriptureRefs, { book: '', chapter: '', startVerse: '', endVerse: '' }]);
  }

  function handleRemoveRef(index) {
    const updated = scriptureRefs.filter((_, i) => i !== index);
    onChange(updated);
  }

  function handleRefChange(index, field, value) {
    const updated = scriptureRefs.map((ref, i) => {
      if (i !== index) return ref;
      return { ...ref, [field]: value };
    });
    onChange(updated);
  }

  return (
    <div className="scripture-ref-editor">
      {scriptureRefs.length === 0 && (
        <p className="scripture-ref-editor-empty">No scripture references added yet.</p>
      )}

      {scriptureRefs.map((ref, index) => (
        <div key={index} className="scripture-ref-editor-entry" data-testid={`scripture-ref-entry-${index}`}>
          <div className="scripture-ref-editor-field">
            <label htmlFor={`scripture-book-${index}`}>Book</label>
            <input
              id={`scripture-book-${index}`}
              type="text"
              value={ref.book || ''}
              onChange={(e) => handleRefChange(index, 'book', e.target.value)}
              placeholder="e.g., Genesis"
            />
          </div>

          <div className="scripture-ref-editor-field">
            <label htmlFor={`scripture-chapter-${index}`}>Chapter</label>
            <input
              id={`scripture-chapter-${index}`}
              type="number"
              min="1"
              value={ref.chapter || ''}
              onChange={(e) => handleRefChange(index, 'chapter', e.target.value)}
              placeholder="Chapter"
            />
          </div>

          <div className="scripture-ref-editor-field">
            <label htmlFor={`scripture-start-verse-${index}`}>Start Verse</label>
            <input
              id={`scripture-start-verse-${index}`}
              type="number"
              min="1"
              value={ref.startVerse || ''}
              onChange={(e) => handleRefChange(index, 'startVerse', e.target.value)}
              placeholder="Start verse"
            />
          </div>

          <div className="scripture-ref-editor-field">
            <label htmlFor={`scripture-end-verse-${index}`}>End Verse (optional)</label>
            <input
              id={`scripture-end-verse-${index}`}
              type="number"
              min="1"
              value={ref.endVerse || ''}
              onChange={(e) => handleRefChange(index, 'endVerse', e.target.value)}
              placeholder="End verse"
            />
          </div>

          <button
            type="button"
            className="scripture-ref-editor-remove-btn"
            onClick={() => handleRemoveRef(index)}
            aria-label={`Remove scripture reference ${index + 1}`}
          >
            Remove
          </button>
        </div>
      ))}

      <button
        type="button"
        className="scripture-ref-editor-add-btn"
        onClick={handleAddRef}
      >
        Add Scripture Reference
      </button>
    </div>
  );
}

export default ScriptureRefEditor;
